import Config from './init.js'
export default {
    install(Vue) {
        Vue.$Config = Vue.prototype.$Config = Config
    }
}